import { ISvgInfo, Shape, SHAPE_ENUM, SVG_ATTR_ENUM } from '../types';

// import { ValueOf } from 'type-fest';

// type RXY = ValueOf<typeof SVG_ATTR_ENUM, 'RX' | 'RY'>;

export const generateSvg = (curShape: Shape, svgInfo: ISvgInfo) => {
    const svgNS = 'http://www.w3.org/2000/svg';
    const svg = document.createElementNS(svgNS, 'svg');
    const svgSize = computedSvgSize(curShape, svgInfo);
    svg.setAttribute('height', svgSize.height.toString());
    svg.setAttribute('width', svgSize.width.toString());
    svg.setAttribute('viewBox', `0 0 ${svgSize.width} ${svgSize.height}`);
    const el = document.createElementNS(svgNS, curShape);
    Object.keys(svgInfo[curShape]).forEach((attr) => {
        let svgValue: any = (svgInfo as any)[curShape][attr];
        // 去除shape 无关属性
        if (attr === SVG_ATTR_ENUM.SHAPE) return;

        if (curShape === SHAPE_ENUM.ELLIPSE && (attr === SVG_ATTR_ENUM.CX || attr === SVG_ATTR_ENUM.CY)) {
            let elPos: number = 0;

            attr === SVG_ATTR_ENUM.CX ? (elPos = svgInfo[curShape].rx) : (elPos = svgInfo[curShape].ry);

            svgValue = (elPos + svgInfo[curShape]['stroke-width'] / 2).toString();

            // el.setAttribute(
            //     attr,
            //     (elPos + svgInfo[curShape]['stroke-width'] / 2).toString()
            // );
            // return;
        } else if (
            curShape === SHAPE_ENUM.RECT &&
            (attr === SVG_ATTR_ENUM.X || attr === SVG_ATTR_ENUM.Y || attr === SVG_ATTR_ENUM.RY)
        ) {
            if (attr === SVG_ATTR_ENUM.RY) {
                el.setAttribute(attr, svgInfo[curShape].rx.toString());
                return;
            }
            svgValue = (svgInfo[curShape][attr] + svgInfo[curShape]['stroke-width'] / 2).toString();

            // el.setAttribute(
            //     attr,
            //     (
            //         svgInfo[curShape][attr] +
            //         svgInfo[curShape]['stroke-width'] / 2
            //     ).toString()
            // );

            // return;
        } else if (
            curShape === SHAPE_ENUM.LINE &&
            (attr === SVG_ATTR_ENUM.X1 ||
                attr === SVG_ATTR_ENUM.Y1 ||
                attr === SVG_ATTR_ENUM.X2 ||
                attr === SVG_ATTR_ENUM.Y2)
        ) {
            // el.setAttribute(
            //     attr,
            //     (
            //         svgInfo[curShape][attr] + svgInfo[curShape]['stroke-width']
            //     ).toString()
            // );
            // return;

            svgValue = (svgInfo[curShape][attr] + svgInfo[curShape]['stroke-width']).toString();
        }

        //如果是颜色的话，转成rgba
        if (attr === SVG_ATTR_ENUM.FILL || attr === SVG_ATTR_ENUM.STROKE_COLOR) {
            svgValue = hexAlpha2Rgba(svgInfo[curShape][attr]);
            // el.setAttribute(attr, hexAlpha2Rgba(svgInfo[curShape][attr]));
            // return;
        }

        el.setAttribute(attr, svgValue);
    });

    svg.appendChild(el);
    const svgContainer = document.querySelector('.design-svg-stage') as HTMLDivElement;
    svgContainer.innerHTML = ''; // 清空容器
    svgContainer.appendChild(svg);
};

const computedSvgSize = (curShape: Shape, svgInfo: ISvgInfo) => {
    if (curShape === SHAPE_ENUM.ELLIPSE) {
        return {
            width: svgInfo[curShape].rx * 2 + svgInfo[curShape]['stroke-width'],
            height: svgInfo[curShape].ry * 2 + svgInfo[curShape]['stroke-width'],
        };
    }

    if (curShape === SHAPE_ENUM.RECT) {
        return {
            width: svgInfo[curShape].width + svgInfo[curShape]['stroke-width'],
            height: svgInfo[curShape].height + svgInfo[curShape]['stroke-width'],
        };
    }
    if (curShape === SHAPE_ENUM.LINE) {
        return {
            width:
                Math.abs(svgInfo[curShape].x1 - svgInfo[curShape].x2) +
                Math.min(svgInfo[curShape].x1, svgInfo[curShape].x2) +
                svgInfo[curShape]['stroke-width'] * 2,
            height:
                Math.abs(svgInfo[curShape].y1 - svgInfo[curShape].y2) +
                Math.min(svgInfo[curShape].y1, svgInfo[curShape].y2) +
                svgInfo[curShape]['stroke-width'] * 2,
        };
    }

    return { width: 0, height: 0 };
};

export const downloadSvg = (curShape: Shape) => {
    const svg = document.querySelector('.design-svg-stage>svg') as SVGElement;

    // 将SVG元素转换为SVG代码
    const svgCode = new XMLSerializer().serializeToString(svg);

    // 创建一个Blob对象存储SVG代码
    const blob = new Blob([svgCode], { type: 'image/svg+xml' });

    // 创建一个下载链接
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `${curShape}.svg`;
    a.textContent = 'Download SVG ';

    // 添加下载链接到页面并触发下载
    document.body.appendChild(a);
    a.click();

    // 清理
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
};

const hexAlpha2Rgba = (hexWithAlpha: string) => {
    hexWithAlpha = hexWithAlpha.replace('#', '');
    const rgbHex = hexWithAlpha.slice(0, 6);
    const alphaHex = hexWithAlpha.slice(6);
    const r = parseInt(rgbHex.substring(0, 2), 16);
    const g = parseInt(rgbHex.substring(2, 4), 16);
    const b = parseInt(rgbHex.substring(4, 6), 16);
    const alpha = parseInt(alphaHex, 16) / 255;
    return `rgba(${r},${g},${b},${alpha})`;
};
